import { ImageRegionEntity } from "~/interfaces/entities/ImageRegion"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: imageRegions,
  selectors: imageRegionsSelectors,
} = createEntitySlice<ImageRegionEntity>("imageRegions")
